export enum EAppsCounters {
	SHOW_MORE_NEW = 65919712,
	SHOW_MORE_INSTALLED = 65919714,
	SHOW_MORE_POPULAR = 57659652,

	SHOW_MORE_STRATEGY = 57659653,
	SHOW_MORE_ROLEPLAY = 57659654,
	SHOW_MORE_LOGIC = 57659655,
	SHOW_MORE_CASUAL = 57659657,
	SHOW_MORE_ROWS = 57659659,
	SHOW_MORE_EXTERNAL = 57659662,
	SHOW_MORE_LUCKY = 57659661,

	MENU_GENRE_ALL = 57659665,
	MENU_STRATEGY = 57659666,
	MENU_ROLEPLAY = 57659667,
	MENU_LOGIC = 57659668,
	MENU_CASUAL = 57659670,
	MENU_ROWS = 57659669,
	MENU_EXTERNAL = 57659673,
	MENU_LUCKY = 57659672,
	MENU_CUSTOM = 57659674,
	MENU_CUSTOM_SHOW_ALL = 57659675,

	PAGINATOR_NEW = 65919716,

	PAGINATOR_STRATEGY = 57659710,
	PAGINATOR_ROLEPLAY = 57659714,
	PAGINATOR_LOGIC = 57659718,
	PAGINATOR_CASUAL = 57659719,
	PAGINATOR_ROWS = 57659720,
	PAGINATOR_EXTERNAL = 57659662,
	PAGINATOR_LUCKY = 57659722,

	APP_REMOVE = 57659724,
	APP_OPTIONS = 57659728,
}
